<template>
  <div v-if="false"></div>
</template>
<script>
export default {
  name: 'mapMarker',
  computed: {
    pinIcon () {
      return this.$props.pinType === 'red' ? '/assets/images/mapPin_red.svg' : '/assets/images/mapPin_green.svg'
    }
  },
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    },
    pinType: {
      type: String,
      default: 'red'
    }
  },
  methods: {
    initMapMarkers () {
      const myLatLng = new this.$props.google.maps.LatLng(this.$props.marker.geoPoint.latitude, this.$props.marker.geoPoint.longitude)
      const marker = new this.$props.google.maps.Marker({
        position: myLatLng,
        marker: this.$props.marker,
        map: this.$props.map,
        icon: this.pinIcon
      })
      this.saveMarkers(marker)
      this.initInfoWindow(marker)
    },
    saveMarkers (marker) {
      if (!this.$props.google.maps._addedMarkers) {
        this.$props.google.maps._addedMarkers = []
      }
      this.$props.google.maps._addedMarkers.push(marker)
    },
    initInfoWindow (marker) {
      const infowindow = new this.google.maps.InfoWindow({
        content: `<h6>${this.$props.marker.name}</h6>` +
          `<p>${this.$props.marker.address.formattedAddress}</p>`
      })

      this.google.maps.event.addListener(marker, 'click', () => {
        if (this.google.maps._openedWindows) {
          this.google.maps._openedWindows.close()
          this.google.maps._openedWindows = null
        }

        setTimeout(() => {
          infowindow.open(this.map, marker)
          this.google.maps._openedWindows = infowindow
        }, 0)
      })
    }
  },
  mounted () {
    this.initMapMarkers()
  }
}
</script>
